module.exports = __webpack_public_path__ + "static/media/react.716502e5.png";